// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#personFrame {
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
}

.invertUnderline {
  text-decoration: none;
}

.invertUnderline:hover {
  text-decoration: underline;
}

.personFrameHeader {
  padding: 5px;
  background-color: #f1f1f1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.personFrameHeader .container-right {
  display: flex;
  align-items: center;
}

.person-link {
  padding-bottom: 10px;
}

.analyse-button-container {
  padding-right: 5px;
  position: relative;
}
.analyse-button-container .sherpa-nouveau {
  position: absolute;
  margin-top: 16px;
  top: -27px;
  left: 12px;
  border-radius: 18px;
  border: 1px solid #FFF;
  background: radial-gradient(221.49% 177.12% at -46.77% 47.5%, #DFDAD4 10.96%, #FE5E2C 48.6%, #575757 99.99%);
  padding: 3px 6px 3px 6px;
  color: #FFF;
  text-align: center;
  font-family: "Arial";
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.analyse-button-container .btn-analyse {
  color: #fff !important;
  font-family: Arial;
  font-size: 15px !important;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 6px 15px 6px 12px;
  border-radius: 3px;
  border: 1px solid #fff;
  background-color: #4D5056;
}
.analyse-button-container .btn-analyse img.intelligence-icon {
  padding: 1px 3px 2px 3px;
  margin-right: 3px;
}
.analyse-button-container .btn-analyse span {
  text-transform: uppercase;
  font-weight: 700;
}

.mainContent {
  padding: 0px;
}

.nameTitle {
  font-size: 17pt;
  padding-left: 6px;
}

.nameTitleCard {
  font-size: 17pt;
  padding: 9px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.nameTitleCard .btn-analyse {
  color: #000;
  font-size: 12pt;
}
@media (max-width: 2000px) {
  .nameTitleCard {
    flex-direction: column;
  }
  .nameTitleCard a {
    margin-top: 10px;
  }
}

.main-container {
  padding: 10px;
  height: 250px;
  overflow-y: auto;
  width: 100%;
}

.competenciesGraphTd {
  width: 110px;
}

.competenciesTd {
  width: 100%;
}

.subCard {
  z-index: 0;
  background-color: #f1f1f1;
  width: 100%;
  position: absolute;
}

.cardHeaderMainTitle {
  font-family: MontserratSemiBold, sans-serif;
  padding-top: 3px;
}

.cardHeader {
  width: auto;
  background-color: rgb(206, 206, 206);
  border-bottom: 2px solid #999;
  padding: 4px 4px 4px 10px;
  height: 50px;
}

.cardHeader * {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.trucateWidth {
  width: calc(100% - 170px);
}

.card {
  width: calc(100% - 4px);
  z-index: 3;
  background-color: white;
}

.leftCard {
  border-left: 6px solid #f1f1f1;
  margin-right: 4px;
}

.middleCard {
  margin-right: 2px;
  margin-left: 2px;
}

.rightCard {
  border-right: 6px solid #f1f1f1;
  margin-left: 4px;
}

.cardContainer {
  padding-right: 0;
  padding-left: 0;
}

p {
  padding-bottom: 0;
}

.textBox {
  width: 100%;
  text-align: center;
}

.score {
  color: rgb(227, 94, 36);
  font-size: 150%;
}

.block {
  background-color: #eee;
  padding: 18px 10px 10px 10px;
  width: calc(50% - 4px);
  height: 90px;
}

.iacOverlay {
  position: absolute;
  width: calc(100% - 4px);
  background-color: white;
  height: 250px;
  opacity: 0.65;
}

.fakeItem {
  background-color: #dddddd;
  line-height: 12px;
}

.fakeIndicator {
  color: #dddddd;
}

.fakeListTable {
  width: 100%;
}

.fakeListTable tr {
  height: 20px;
}

.fakeListTable tr td:last-child {
  width: 20px;
}

.notCompleted {
  position: absolute;
  height: 250px;
  width: calc(100% - 4px);
  font-family: sans-serif;
  font-size: 20px;
  fill: rgb(86, 86, 86);
}

.notCompletedTxt {
  margin: auto;
  width: -moz-fit-content;
  width: fit-content;
  margin: 95px auto 0 auto;
}

.btn-person-card:focus-visible, .btn-person-card:focus, .btn-person-card.focus {
  background-color: #fff;
  outline: none;
  border-color: #ccc;
}

.cards {
  float: left;
  position: relative;
  width: 100%;
  background-color: #f1f1f1;
}

.cardsGrid {
  padding-bottom: 2px;
}

.cardGridView {
  margin: auto;
}

/* Firefox (uncomment to work in Firefox, although other properties will not work!)  */
/** {
  scrollbar-width: thin;
  scrollbar-color: #CCCCCC #FFFFFF;
}*/
/* Chrome, Edge and Safari */
*::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}

*::-webkit-scrollbar-track {
  border-radius: 28px;
  background-color: transparent;
  border: 1px solid #DFE0E2;
}

*::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: #DFE0E2;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #919191;
  border: 1px solid #919191;
}

*::-webkit-scrollbar-thumb:active {
  background-color: #6B6B6B;
  border: 1px solid #6B6B6B;
}

.overlay {
  position: fixed;
  top: 0;
  left: 502px;
  width: calc(100% - 502px);
  height: 100%;
  background: radial-gradient(205.31% 178.34% at -11.22% -17.87%, rgba(244, 245, 245, 0.5) 0%, rgba(254, 94, 44, 0.75) 41.96%, rgba(41, 44, 50, 0.95) 81.88%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.close-button {
  position: absolute;
  right: 24px;
  top: 24px;
  background-color: transparent;
}

.overlay > div.rightmatch-analysis-container {
  position: fixed;
  top: 50%;
  left: calc(50% + 251px);
  transform: translate(-50%, -50%);
  width: 600px;
  height: 750px;
  max-height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  align-content: stretch;
  border-radius: 26px;
}
.overlay > div.rightmatch-analysis-container .header-container {
  position: relative;
  width: 100%;
  height: 56px;
  background-color: #fff;
  border-radius: 26px 26px 0 0;
}
.overlay > div.rightmatch-analysis-container .header-container.footer {
  border-radius: 0 0 26px 26px;
}
.overlay > div.rightmatch-analysis-container .header-container .x-close {
  position: absolute;
  right: 20px;
  top: 20px;
  color: #000;
  z-index: 9999;
}
.overlay > div.rightmatch-analysis-container .header-container .x-close:hover {
  color: #7A7A7A;
}
.overlay > div.rightmatch-analysis-container .header-container .analyse-header {
  padding: 15px;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  margin: 0 auto;
  display: flex;
}
.overlay > div.rightmatch-analysis-container .header-container .analyse-header h4.analyse-header-title {
  color: #292C32;
  text-align: center;
  font-family: "Arial Black";
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}
.overlay > div.rightmatch-analysis-container .analyse-container {
  position: relative;
  margin: 20px 0;
  width: 100%;
  flex: 2 1 auto;
  overflow: auto;
  padding: 10px 10px;
  margin-right: 20px;
}
.overlay > div.rightmatch-analysis-container .analyse-container .analyse-content {
  padding: 10px;
  width: 95%;
  margin: 0 auto;
}
.overlay > div.rightmatch-analysis-container .gradient-background {
  position: relative;
  width: 100%;
  height: 60px;
  background: linear-gradient(0deg, #fff 19.26%, rgba(255, 255, 255, 0) 100%);
  z-index: 10;
  top: -20px;
  margin: -40px;
  width: 95%;
}
.overlay > div.rightmatch-analysis-container .analysis-graph-container {
  width: 100%;
  padding: 24px 24px 0px;
}
.overlay > div.rightmatch-analysis-container .analysis-graph-container h3 {
  text-align: center;
  color: #292C32;
  /* small */
  font-family: Arial;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 160% */
  padding-bottom: 10px;
}
.overlay > div.rightmatch-analysis-container .analysis-graph-container .mpo-graph {
  display: flex;
  width: 60%;
  margin: 0 auto;
  padding-bottom: 30px;
}
.overlay > div.rightmatch-analysis-container .analysis-footer .iconButton {
  background-color: transparent;
  padding: 0 3px;
  margin-left: 3px;
}
.overlay > div.rightmatch-analysis-container .analysis-footer .iconButton:last-of-type {
  padding-right: 0;
}
.overlay > div.rightmatch-analysis-container .analysis-footer-container {
  width: 100%;
  padding: 12px 24px 24px;
}

@media (max-height: 925px) {
  div.rightmatch-analysis-container {
    width: 520px !important;
    height: 600px !important;
  }
  .overlay > div.rightmatch-analysis-container .gradient-background {
    height: 50px !important;
    top: -10px !important;
    margin: -30px !important;
  }
  .overlay > div.rightmatch-analysis-container .gradient-background {
    width: 93%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/analysis/right-matches/components/commonClasses/right-matches-person-card/right-matches-person-card.component.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,kBAAA;EACA,UAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;AAER;;AACA;EACI,oBAAA;AAEJ;;AAAA;EACI,kBAAA;EACA,kBAAA;AAGJ;AAFI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,UAAA;EACA,mBAAA;EACA,sBAAA;EACA,4GAAA;EACA,wBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAIR;AADI;EACI,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAGR;AAFQ;EACI,wBAAA;EACA,iBAAA;AAIZ;AAFQ;EACI,yBAAA;EACA,gBAAA;AAIZ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,eAAA;EACA,iBAAA;AAEJ;;AAGA;EACI,eAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAAJ;AACI;EACI,WAAA;EACA,eAAA;AACR;AACI;EAbJ;IAcQ,sBAAA;EAEN;EADM;IACI,gBAAA;EAGV;AACF;;AACA;EACI,aAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AAEJ;;AACA;EACI,YAAA;AAEJ;;AACA;EACI,WAAA;AAEJ;;AACA;EACI,UAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;AAEJ;;AACA;EACI,2CAAA;EACA,gBAAA;AAEJ;;AACA;EACI,WAAA;EACA,oCAAA;EACA,6BAAA;EACA,yBAAA;EACA,YAAA;AAEJ;;AACA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEJ;;AACA;EACI,yBAAA;AAEJ;;AACA;EACI,uBAAA;EACA,UAAA;EACA,uBAAA;AAEJ;;AACA;EACI,8BAAA;EACA,iBAAA;AAEJ;;AACA;EACI,iBAAA;EACA,gBAAA;AAEJ;;AACA;EACI,+BAAA;EACA,gBAAA;AAEJ;;AACA;EACI,gBAAA;EACA,eAAA;AAEJ;;AACA;EACI,iBAAA;AAEJ;;AAGA;EACI,WAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,uBAAA;EACA,eAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,cAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA;EACI,WAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,eAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,wBAAA;AAAJ;;AAGA;EACI,sBAAA;EACA,aAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,mBAAA;AAAJ;;AAGA;EACI,YAAA;AAAJ;;AAGA,sFAAA;AACA;;;EAAA;AAKA,4BAAA;AACA;EACI,WAAA;EACA,UAAA;AADJ;;AAIE;EACE,mBAAA;EACA,6BAAA;EACA,yBAAA;AADJ;;AAIE;EACE,mBAAA;EACA,yBAAA;AADJ;;AAIE;EACE,yBAAA;EACA,yBAAA;AADJ;;AAIE;EACE,yBAAA;EACA,yBAAA;AADJ;;AAKA;EACI,eAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,2JAAA;EAIA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AALJ;;AAOA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;AAJJ;;AAOA;EACI,eAAA;EACA,QAAA;EACA,uBAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AAJJ;AAKK;EACG,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;AAHR;AAIQ;EACI,4BAAA;AAFZ;AAIQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EAEA,aAAA;AAHZ;AAIY;EACI,cAAA;AAFhB;AAKQ;EACI,aAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,cAAA;EACA,aAAA;AAHZ;AAKY;EACI,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHhB;AAOI;EACI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AALR;AAMQ;EACI,aAAA;EACA,UAAA;EACA,cAAA;AAJZ;AAQI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,2EAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;AANR;AASI;EACI,WAAA;EACA,sBAAA;AAPR;AAQQ;EACI,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,oBAAA;AANZ;AAQQ;EACI,aAAA;EACA,UAAA;EACA,cAAA;EACA,oBAAA;AANZ;AAUQ;EACI,6BAAA;EACA,cAAA;EACA,gBAAA;AARZ;AASY;EACI,gBAAA;AAPhB;AAWI;EACI,WAAA;EACA,uBAAA;AATR;;AAaA;EACI;IACI,uBAAA;IACA,wBAAA;EAVN;EAaE;IACI,uBAAA;IACA,qBAAA;IACA,wBAAA;EAXN;EAcE;IACI,UAAA;EAZN;AACF","sourcesContent":["#personFrame {\n    margin-bottom: 20px;\n    position: relative;\n    z-index: 1;\n}\n\n.invertUnderline {\n    text-decoration: none;\n}\n\n.invertUnderline:hover {\n    text-decoration: underline;\n}\n\n.personFrameHeader {\n    padding: 5px;\n    background-color: #f1f1f1;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    .container-right {\n        display: flex;\n        align-items: center;\n    }\n}\n.person-link {\n    padding-bottom: 10px;\n}\n.analyse-button-container {\n    padding-right: 5px;\n    position: relative;\n    .sherpa-nouveau {\n        position: absolute;\n        margin-top: 16px;\n        top: -27px;\n        left: 12px;\n        border-radius: 18px;\n        border: 1px solid #FFF;\n        background: radial-gradient(221.49% 177.12% at -46.77% 47.5%, #DFDAD4 10.96%, #FE5E2C 48.6%, #575757 99.99%);\n        padding: 3px 6px 3px 6px;\n        color: #FFF;\n        text-align: center;\n        font-family: 'Arial';\n        font-size: 9px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: normal;\n        \n    }\n    .btn-analyse {\n        color: #fff!important;  \n        font-family: Arial;\n        font-size: 15px!important;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 20px;\n        padding: 6px 15px 6px 12px;\n        border-radius: 3px;\n        border: 1px solid #fff;\n        background-color: #4D5056;\n        img.intelligence-icon {\n            padding: 1px 3px 2px 3px;\n            margin-right: 3px;\n        }\n        span {\n            text-transform: uppercase;\n            font-weight: 700;\n        }\n    }\n}\n\n.mainContent {\n    padding: 0px;\n}\n\n.nameTitle {\n    font-size: 17pt;\n    padding-left: 6px;\n}\n\n\n\n.nameTitleCard {\n    font-size: 17pt;\n    padding: 9px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    .btn-analyse {\n        color: #000;\n        font-size: 12pt;\n    }\n    @media (max-width: 2000px) {\n        flex-direction: column;\n        a {\n            margin-top: 10px;\n        }\n    }\n}\n\n.main-container {\n    padding: 10px;\n    height: 250px;\n    overflow-y: auto;\n    width: 100%;\n}\n\n.competenciesGraphTd {\n    width: 110px;\n}\n\n.competenciesTd {\n    width: 100%;\n}\n\n.subCard {\n    z-index: 0;\n    background-color: #f1f1f1;\n    width: 100%;\n    position: absolute;\n}\n\n.cardHeaderMainTitle {\n    font-family: MontserratSemiBold,  sans-serif;\n    padding-top: 3px;\n}\n\n.cardHeader {\n    width: auto;\n    background-color: rgb(206, 206, 206);\n    border-bottom: 2px solid #999;\n    padding: 4px 4px 4px 10px;\n    height: 50px;\n}\n\n.cardHeader * {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.trucateWidth {\n    width: calc(100% - 170px);\n}\n\n.card {\n    width: calc(100% - 4px);\n    z-index: 3;\n    background-color: white;\n}\n\n.leftCard {\n    border-left: 6px solid #f1f1f1;\n    margin-right: 4px;\n}\n\n.middleCard {\n    margin-right: 2px;\n    margin-left: 2px;\n}\n\n.rightCard {\n    border-right: 6px solid #f1f1f1;\n    margin-left: 4px;\n}\n\n.cardContainer {\n    padding-right: 0;\n    padding-left: 0;\n}\n\np {\n    padding-bottom: 0;\n}\n\n\n\n.textBox {\n    width: 100%;\n    text-align: center;\n}\n\n.score {\n    color: rgb(227, 94, 36);\n    font-size: 150%;\n}\n\n.block {\n    background-color: #eee;\n    padding: 18px 10px 10px 10px;\n    width: calc(50% - 4px);\n    height: 90px;\n}\n\n.iacOverlay {\n    position: absolute;\n    width: calc(100% - 4px);\n    background-color: white;\n    height: 250px;\n    opacity: 0.65;\n}\n\n.fakeItem {\n    background-color: #dddddd;\n    line-height: 12px;\n}\n\n.fakeIndicator {\n    color: #dddddd;\n}\n\n.fakeListTable {\n    width: 100%;\n}\n\n.fakeListTable tr {\n    height: 20px;\n}\n\n.fakeListTable tr td:last-child {\n    width: 20px;\n}\n\n.notCompleted {\n    position: absolute;\n    height: 250px;\n    width: calc(100% - 4px);\n    font-family: sans-serif;\n    font-size: 20px;\n    fill: rgb(86, 86, 86);\n}\n\n.notCompletedTxt {\n    margin: auto;\n    width: fit-content;\n    margin: 95px auto 0 auto;\n}\n\n.btn-person-card:focus-visible, .btn-person-card:focus, .btn-person-card.focus {\n    background-color: #fff;\n    outline: none;\n    border-color: #ccc;\n}\n\n.cards {\n    float: left;\n    position: relative;\n    width: 100%;\n    background-color: #f1f1f1;\n}\n\n.cardsGrid {\n    padding-bottom: 2px;\n}\n\n.cardGridView {\n    margin: auto;\n}\n\n/* Firefox (uncomment to work in Firefox, although other properties will not work!)  */\n/** {\n  scrollbar-width: thin;\n  scrollbar-color: #CCCCCC #FFFFFF;\n}*/\n\n/* Chrome, Edge and Safari */\n*::-webkit-scrollbar {\n    height: 5px;\n    width: 5px;\n  }\n  \n  *::-webkit-scrollbar-track {\n    border-radius: 28px;\n    background-color: transparent;\n    border: 1px solid #DFE0E2;\n  }\n  \n  *::-webkit-scrollbar-thumb {\n    border-radius: 20px;\n    background-color: #DFE0E2;\n  }\n  \n  *::-webkit-scrollbar-thumb:hover {\n    background-color: #919191;\n    border: 1px solid #919191;\n  }\n  \n  *::-webkit-scrollbar-thumb:active {\n    background-color: #6B6B6B;\n    border: 1px solid #6B6B6B;\n  \n  }\n\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 502px;\n    width: calc(100% - 502px);\n    height: 100%;\n    background: radial-gradient(205.31% 178.34% at -11.22% -17.87%, \n                rgba(244, 245, 245, 0.50) 0%, \n                rgba(254, 94, 44, 0.75) 41.96%, \n                rgba(41, 44, 50, 0.95) 81.88%);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2;\n}\n.close-button {\n    position: absolute;\n    right: 24px;\n    top: 24px;\n    background-color: transparent;    \n}\n\n.overlay > div.rightmatch-analysis-container {\n    position: fixed;\n    top: 50%;\n    left: calc(50% + 502px / 2);\n    transform: translate(-50%, -50%);\n    width: 600px;\n    height: 750px;\n    max-height: 100%;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    align-content: stretch;\n    border-radius: 26px;\n     .header-container {\n        position: relative;\n        width: 100%;\n        height: 56px;\n        background-color: #fff;\n        border-radius: 26px 26px 0 0;\n        &.footer {\n            border-radius: 0 0 26px 26px;\n        }\n        .x-close {\n            position: absolute;\n            right: 20px;\n            top: 20px;\n            color: #000;\n            // for debugging. Makes the X clickable\n            z-index: 9999;\n            &:hover {\n                color: #7A7A7A;\n            }\n        }\n        .analyse-header {\n            padding: 15px;\n            width: 100%;\n            height: fit-content;\n            margin: 0 auto;\n            display: flex;\n            \n            h4.analyse-header-title {\n                color: #292C32;\n                text-align: center;\n                font-family: \"Arial Black\";\n                font-size: 40px;\n                font-style: normal;\n                font-weight: 900;\n                line-height: normal;\n            }\n         }\n    }\n    .analyse-container {\n        position: relative;\n        margin: 20px 0;\n        width: 100%;\n        flex: 2 1 auto;\n        overflow: auto;\n        padding: 10px 10px;\n        margin-right: 20px;\n        .analyse-content {\n            padding: 10px;\n            width: 95%;\n            margin: 0 auto;\n        }\n        \n    }\n    .gradient-background {\n        position: relative;\n        width: 100%;\n        height: 60px;\n        background: linear-gradient(0deg, #fff 19.26%, rgba(255, 255, 255, 0) 100%);\n        z-index: 10;\n        top: -20px;\n        margin: -40px;\n        width: 95%;\n        }\n    \n    .analysis-graph-container {\n        width: 100%;\n        padding: 24px 24px 0px;\n        h3 {\n            text-align: center;\n            color: #292C32;\n            /* small */\n            font-family: Arial;\n            font-size: 15px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 24px; /* 160% */\n            padding-bottom: 10px;\n        }\n        .mpo-graph {\n            display: flex;\n            width: 60%;\n            margin: 0 auto;\n            padding-bottom: 30px;\n        }\n    }\n    .analysis-footer {\n        .iconButton {\n            background-color: transparent;\n            padding: 0 3px;\n            margin-left: 3px;\n            &:last-of-type {\n                padding-right: 0;\n            }\n        }\n    } \n    .analysis-footer-container {\n        width: 100%;\n        padding: 12px 24px 24px;;\n    }\n}\n\n@media (max-height: 925px) {\n    div.rightmatch-analysis-container{\n        width: 520px!important;\n        height: 600px!important;\n    }\n\n    .overlay > div.rightmatch-analysis-container .gradient-background {\n        height: 50px!important;\n        top: -10px!important;\n        margin: -30px!important;\n    }\n\n    .overlay > div.rightmatch-analysis-container .gradient-background {\n        width: 93%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
